import { render, staticRenderFns } from "./clickOPPO.vue?vue&type=template&id=0c6677e5&scoped=true"
import script from "./clickOPPO.vue?vue&type=script&lang=js"
export * from "./clickOPPO.vue?vue&type=script&lang=js"
import style0 from "./clickOPPO.vue?vue&type=style&index=0&id=0c6677e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6677e5",
  null
  
)

export default component.exports